var _rect, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeLensIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 867,
    height: 298,
    viewBox: "0 0 867 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55107_32018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 795,
    height: 259
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.1582,
    width: 794,
    height: 259,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55107_32018)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_55107_32018",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.244 162.422C685.363 162.502 685.49 162.569 685.623 162.622C803.096 209.45 880.158 288.05 880.158 377.116C880.158 520.646 680.029 637 433.158 637C186.287 637 -13.8418 520.646 -13.8418 377.116C-13.8418 288.051 63.219 209.451 180.691 162.623C180.823 162.57 180.951 162.503 181.069 162.423C245.72 118.896 334.802 92 433.158 92C531.513 92 620.593 118.896 685.244 162.422Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.691 162.623L174.396 146.831L180.691 162.623ZM181.069 162.423L190.564 176.525L181.069 162.423ZM685.623 162.622L679.328 178.413L685.623 162.622ZM685.244 162.422L675.75 176.524L685.244 162.422ZM679.328 178.413C794.609 224.367 863.158 298.682 863.158 377.116H897.158C897.158 277.419 811.583 194.532 691.918 146.83L679.328 178.413ZM863.158 377.116C863.158 440.296 818.982 500.667 740.69 546.185C662.826 591.455 554.135 620 433.158 620V654C559.053 654 673.862 624.368 757.779 575.578C841.27 527.037 897.158 457.466 897.158 377.116H863.158ZM433.158 620C312.182 620 203.49 591.455 125.626 546.185C47.3343 500.667 3.1582 440.296 3.1582 377.116H-30.8418C-30.8418 457.466 25.0464 527.037 108.537 575.578C192.455 624.368 307.263 654 433.158 654V620ZM3.1582 377.116C3.1582 298.682 71.7059 224.369 186.986 178.414L174.396 146.831C54.7321 194.533 -30.8418 277.42 -30.8418 377.116H3.1582ZM190.564 176.525C252.058 135.124 337.735 109 433.158 109V75C331.868 75 239.383 102.669 171.575 148.321L190.564 176.525ZM433.158 109C528.579 109 614.256 135.123 675.75 176.524L694.738 148.32C626.931 102.669 534.446 75 433.158 75V109ZM186.986 178.414C188.226 177.92 189.428 177.29 190.564 176.525L171.575 148.321C172.474 147.716 173.421 147.22 174.396 146.831L186.986 178.414ZM691.918 146.83C692.892 147.219 693.839 147.715 694.738 148.32L675.75 176.524C676.886 177.289 678.088 177.919 679.328 178.413L691.918 146.83Z",
    fill: "url(#paint0_linear_55107_32018)",
    mask: "url(#path-2-inside-1_55107_32018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.158 754L434.158 -15",
    stroke: "#787878",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.158 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.158 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.158 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.158 16V212",
    stroke: "#00425B",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3218 208.795C38.0751 210.027 39.0365 212 40.7897 212L80.7663 212C81.1295 212 81.4859 211.901 81.7972 211.714L145.904 173.153C146.073 173.052 146.223 172.928 146.355 172.782C161.68 155.858 188.162 133.88 231.659 115.743C277.74 96.5272 342.919 76.5168 434.159 76.5001C525.014 76.5167 590.289 96.4019 636.592 115.5C680.683 133.686 707.572 155.787 722.966 172.787C723.096 172.93 723.242 173.051 723.406 173.151L786.516 211.707C786.829 211.899 787.19 212 787.558 212H825.567C827.314 212 828.277 210.04 827.042 208.804C804.392 186.141 659.525 50.6093 434.298 50.5C434.28 50.5 434.262 50.5 434.244 50.5C434.204 50.5 434.163 50.5 434.122 50.5C434.082 50.5 434.041 50.5 434.001 50.5C433.983 50.5 433.965 50.5 433.947 50.5C208.752 50.6093 62.2744 186.103 39.3218 208.795Z",
    fill: "#00486A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.014 754.479C423.279 754.558 423.558 754.408 423.637 754.144L424.931 749.834C425.01 749.569 424.86 749.291 424.596 749.211C424.331 749.132 424.053 749.282 423.973 749.546L422.823 753.377L418.992 752.227C418.728 752.148 418.449 752.298 418.369 752.562C418.29 752.827 418.44 753.106 418.704 753.185L423.014 754.479ZM119.718 191.237L422.718 754.237L423.598 753.763L120.598 190.763L119.718 191.237Z",
    fill: "url(#paint1_linear_55107_32018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.717 562.236C427.847 562.479 428.15 562.571 428.394 562.441L432.362 560.319C432.606 560.189 432.698 559.886 432.568 559.643C432.437 559.399 432.134 559.307 431.891 559.437L428.363 561.323L426.477 557.796C426.347 557.552 426.044 557.46 425.801 557.591C425.557 557.721 425.465 558.024 425.596 558.267L427.717 562.236ZM568.68 96.8549L427.68 561.855L428.637 562.145L569.637 97.1451L568.68 96.8549Z",
    fill: "url(#paint2_linear_55107_32018)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_55107_32018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 795,
    height: 259
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1582 0H830.158V259H36.1582V0Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_55107_32018)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-2_55107_32018",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.422 162.542C803.008 209.36 880.158 288 880.158 377.116C880.158 520.646 680.029 637 433.158 637C186.287 637 -13.8418 520.646 -13.8418 377.116C-13.8418 288 63.3069 209.361 180.892 162.543C245.557 118.946 334.712 92 433.158 92C531.603 92 620.757 118.945 685.422 162.542Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M685.422 162.542L675.919 176.637L677.435 177.659L679.133 178.336L685.422 162.542ZM180.892 162.543L187.18 178.337L188.879 177.661L190.395 176.638L180.892 162.543ZM679.133 178.336C794.529 224.282 863.158 298.637 863.158 377.116H897.158C897.158 277.363 811.487 194.438 691.71 146.748L679.133 178.336ZM863.158 377.116C863.158 440.296 818.982 500.667 740.69 546.185C662.826 591.455 554.135 620 433.158 620V654C559.053 654 673.862 624.368 757.779 575.578C841.27 527.037 897.158 457.466 897.158 377.116H863.158ZM433.158 620C312.182 620 203.49 591.455 125.626 546.185C47.3343 500.667 3.1582 440.296 3.1582 377.116H-30.8418C-30.8418 457.466 25.0464 527.037 108.537 575.578C192.455 624.368 307.263 654 433.158 654V620ZM3.1582 377.116C3.1582 298.637 71.7858 224.283 187.18 178.337L174.603 146.749C54.828 194.439 -30.8418 277.363 -30.8418 377.116H3.1582ZM190.395 176.638C251.901 135.172 337.647 109 433.158 109V75C331.776 75 239.213 102.72 171.388 148.447L190.395 176.638ZM433.158 109C528.667 109 614.413 135.171 675.919 176.637L694.925 148.446C627.1 102.719 534.538 75 433.158 75V109Z",
    fill: "url(#paint3_linear_55107_32018)",
    mask: "url(#path-13-inside-2_55107_32018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.158 754L434.158 -15",
    stroke: "#787878",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6582 212H81.3211L146.158 173C161.452 156.047 187.975 133.958 231.658 115.743C277.74 96.5271 342.919 76.5167 434.158 76.5C525.014 76.5166 590.288 96.4019 636.592 115.5C680.867 133.761 707.796 155.972 723.158 173L786.995 212H824.658",
    stroke: "#07779E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.014 754.479C423.279 754.558 423.558 754.408 423.637 754.144L424.931 749.834C425.01 749.569 424.86 749.291 424.596 749.211C424.331 749.132 424.053 749.282 423.973 749.546L422.823 753.377L418.992 752.227C418.728 752.148 418.449 752.298 418.369 752.562C418.29 752.827 418.44 753.106 418.704 753.185L423.014 754.479ZM119.718 191.237L422.718 754.237L423.598 753.763L120.598 190.763L119.718 191.237Z",
    fill: "url(#paint4_linear_55107_32018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.717 562.236C427.847 562.479 428.15 562.571 428.394 562.441L432.362 560.319C432.606 560.189 432.698 559.886 432.568 559.643C432.437 559.399 432.134 559.307 431.891 559.437L428.363 561.323L426.477 557.796C426.347 557.552 426.044 557.46 425.801 557.591C425.557 557.721 425.465 558.024 425.596 558.267L427.717 562.236ZM568.68 96.8549L427.68 561.855L428.637 562.145L569.637 97.1451L568.68 96.8549Z",
    fill: "url(#paint5_linear_55107_32018)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.158 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.158 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.158 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.158 0V231",
    stroke: "#899295",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55107_32018",
    x1: 433.158,
    y1: 92,
    x2: 433.158,
    y2: 318.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55107_32018",
    x1: 179.158,
    y1: 300.5,
    x2: 91.6582,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55107_32018",
    x1: 575.158,
    y1: 97,
    x2: 504.158,
    y2: 297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17617,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55107_32018",
    x1: 433.158,
    y1: 92,
    x2: 433.158,
    y2: 318.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55107_32018",
    x1: 179.158,
    y1: 300.5,
    x2: 91.6582,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_55107_32018",
    x1: 575.158,
    y1: 97,
    x2: 504.158,
    y2: 297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17617,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeLensIcon);
export default __webpack_public_path__ + "static/media/LargeLensIcon.f02f49058bc249edcc180e89678edee3.svg";
export { ForwardRef as ReactComponent };